import { render, staticRenderFns } from "./VirtualSlides.vue?vue&type=template&id=0799c93c&scoped=true&lang=pug&"
import script from "./VirtualSlides.vue?vue&type=script&lang=js&"
export * from "./VirtualSlides.vue?vue&type=script&lang=js&"
import style0 from "./VirtualSlides.vue?vue&type=style&index=0&id=0799c93c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799c93c",
  null
  
)

export default component.exports